import { Badge } from "@components/ui/badge";
// import Tooltip from "@ui/external/components/tooltip";
import { UserProfile } from "@ui/internal/components/card";
import { useHandleAction } from "@utils/hook/index.hook";
import { ColumnType } from "@utils/interface/index.interface";
import { PaymentData } from "@utils/interface/journey.interface";
import { useSelectionStore } from "@utils/states/index.state";

const ColumnList = () => {
  const { handleAction } = useHandleAction({});
  const { clearSelection } = useSelectionStore();

  const column: ColumnType<PaymentData>[] = [
    {
      name: "ID",
      cell: (row) => (
        <span className="font-semibold text-gray-700">{row.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Date",
      cell: (row) =>
        row?.date ? (
          <span>
            {new Intl.DateTimeFormat("en-US", {
              day: "2-digit",
              year: "numeric",
              month: "short",
            }).format(new Date(row?.date))}
          </span>
        ) : (
          "N?A"
        ),
    },

    {
      name: "Invoice No.",
      cell: (row) => row.invoice.invoice_no,
      sortable: true,
    },
    {
      name: "Student Name",
      cell: (row) => (
        <>
          <UserProfile
            userdesignation={row.student.user.email}
            userimage={row.student.user.professional_image}
            username={row.student.user.full_name}
          />
        </>
      ),
      sortable: false,
    },
    {
      name: "Course & Batch",
      cell: (row) => (
        <Badge variant={"warning"}>{row.invoice.course_batch.name}</Badge>
      ),
      sortable: false,
    },
    {
      name: "Total  Amount",
      cell: (row) => row.invoice?.total_amount,
      sortable: false,
    },
    {
      name: "Total Paid  Amount",
      cell: (row) => row.total_paid_amount,
      sortable: false,
    },
    {
      name: "Due Amount",
      cell: (row) => row.payment_due,
      sortable: false,
    },
    {
      name: "Payment Number",
      cell: (row) => row.payment_number,
      sortable: false,
    },
    {
      name: "Course type",
      cell: (row) => (
        <div>
          {row.is_see && (
            <span className="bg-amber-500 px-2 py-[2px] rounded-full">SEE</span>
          )}
          {row.is_plus2 && (
            <span className="bg-amber-500 px-2 py-[2px] rounded-full">
              Plus 2
            </span>
          )}
          {row.is_masterclass && (
            <span className="bg-amber-500 px-2 py-[2px] rounded-full">
              Master Class
            </span>
          )}
          {!row.is_see && !row.is_plus2 && !row.is_masterclass && (
            <span className="bg-amber-500 px-2 py-[2px] rounded-full">
              Normal
            </span>
          )}
        </div>
      ),
      sortable: false,
    },
    {
      name: "Status",
      cell: (row) => row.invoice.status.replace(/_/g, " "),
      sortable: false,
    },

    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center gap-3 text-[#1daa7e] cursor-pointer">
          {/* <button
            className="text-[#1DA077] cursor-pointer"
            onClick={() => console.log("this is print!")}
          >
            Edit
          </button> */}
          {row?.latest_payment ? (
            // <Tooltip
            //   description={
            //     row?.latest_payment
            //       ? "Only latest Payments Can be Deleted"
            //       : "Delete"
            //   }
            // >
            <button
              className="text-[#C33241] cursor-pointer"
              // disabled={row?.latest_payment}
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
            >
              Delete
            </button>
          ) : (
            //</Tooltip>
            <p>--</p>
          )}
        </div>
      ),
      sortable: false,
    },
  ];
  return column;
};

export { ColumnList };
